export default "__VITE_ASSET__DiOs6jQv__"